export const GA_ACCOUNT = 'G-Z28Y4T51Z8'

export const ANALYTICS__FAILURE = 'analyticsFailure'
export const ANALYTICS__SUCCESS = 'analyticsSuccess'
